module.exports = __webpack_public_path__ + "img/4597bf2.png";